import { render } from "./SetupTwoFaAtUserProfile.vue?vue&type=template&id=67a898c8&scoped=true"
import script from "./SetupTwoFaAtUserProfile.vue?vue&type=script&lang=js"
export * from "./SetupTwoFaAtUserProfile.vue?vue&type=script&lang=js"

import "./SetupTwoFaAtUserProfile.vue?vue&type=style&index=0&id=67a898c8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a898c8"]])

export default __exports__